export default class QueryFrom {
	/** @param {any} from */
	constructor(from = null) {
		/** @type {number} */
		this.inherits_extended = from?.inherits_extended ?? -1;

		/** @type {string} */
		this.name = from?.name ?? '';

		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.node = from?.kid ?? from?.node ?? null;

		/** @type {any[]} */
		this.path = from?.path ?? [];

		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.type = from?.type ?? 'K_NODE;STRING';
	}
}
